import { CommonModule } from '@angular/common';
import { Component, inject } from '@angular/core';
import {
  RdsDialogModule,
  RdsButtonModule,
  RdsListItemModule,
  RdsAvatarModule,
  RDS_DIALOG_DATA,
} from '@rds/angular-components';
import { Role } from '../../../../enums/role.enum';

@Component({
  selector: 'inexp-focus-contributors-dialog',
  imports: [
    RdsDialogModule,
    RdsButtonModule,
    RdsListItemModule,
    RdsAvatarModule,
    CommonModule,
  ],
  templateUrl: './focus-contributors-dialog.component.html',
  styleUrl: './focus-contributors-dialog.component.scss',
})
export class FocusContributorsDialogComponent {
  protected readonly data = inject(RDS_DIALOG_DATA) as {
    authorEmails: string[];
    deputyEmail: string;
    ownerEmail: string;
  };
  roles = Object.values(Role);
}
